<template>
  <div>
    <OrderEdit :data="data"></OrderEdit>
  </div>
</template>


<script>
  import {db, fb} from '../firebase'
  import OrderEdit from '../components/OrderEdit';

  export default {
    name: 'CreateOrder',
    components: {
      OrderEdit
    },
    data () {
      return {
        data: {
          mode: 'createOrder',
          
          /* 注文の情報 */
          name: '',
          address: null,
          latitude: 0,
          longitude: 0,
          destinationName: '',
          clientName: '',
          selected_driver_id: null,

          /* Input Form */ 
          searchAddressInput: '', // 空ままで良い（UpdateOrder.vue用）

          isLoading: false,
          company: null
        }
      }
    },
    methods: {
      async submitOrder() {
        try {
          this.data.isLoading = true

          await db.collection("companies").doc(this.data.company.id).collection('orders').add({
            client: this.data.clientName,
            status: "preparing",
            driver_id: this.data.selected_driver_id,
            destination_name: this.data.destinationName,
            destination_address: this.data.address,
            destination_latitude: this.data.latitude,
            destination_longitude: this.data.longitude,
            createdAt: fb.firestore.Timestamp.fromDate(new Date()), //https://stackoverflow.com/a/47969509/1709287
            name: this.data.name, // (EditOrder機能) TODO 追加しました（今の所は必須項目じゃないですので「””」　となります ）
                                  // その影響で、OrderDetailで１行を変えました。だけです。他のところもチェックする予定
          })

          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 500) // resolve
          })
          this.$router.replace({ name: 'Home'})
        }catch(error){
          console.error("Error adding document: ", error);
          this.data.isLoading = false
        }
      },
    } 
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/CreateOrder.vue